import * as nativeRuleset from './native.ruleset';
import * as nativeSchema from './native.schema';
import * as nativeGetters from './native.getters';
import { nativeActions } from './native.actions';
import { ReplicantModuleState } from '../utils';
import { Immutable } from '@play-co/replicant';
import { Inventory } from '../buruburu/inventory';

export type { NativePromoOrigin } from './native.ruleset';

export type Native = typeof Native;
// eslint-disable-next-line no-redeclare
export namespace Native {
  export const $DEPENDENCIES = { Inventory };
  export const ruleset = nativeRuleset;
  export const schema = nativeSchema;
  export const actions = nativeActions;

  export const api = {
    ...nativeGetters,
  };

  export type MutableState = ReplicantModuleState<Native>;
  export type State = Immutable<MutableState>;
}
